var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusOrangeVector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.88401 1.26882C8.64513 0.8531 12.4407 0.8531 16.2019 1.26882C18.2843 1.50184 19.9644 3.13899 20.2087 5.22518C20.6544 9.03346 20.6544 12.8806 20.2087 16.6889C19.9644 18.7751 18.2843 20.4122 16.2019 20.6452C12.4407 21.061 8.64513 21.061 4.88401 20.6452C2.80157 20.4122 1.12152 18.7751 0.877166 16.6889C0.43157 12.881 0.43157 9.03427 0.877166 5.22639C1.00076 4.21287 1.46358 3.27072 2.19061 2.55263C2.91765 1.83454 3.86629 1.38259 4.88279 1.27004M10.5429 4.8975C10.7847 4.8975 11.0167 4.9934 11.1876 5.16409C11.3586 5.33479 11.4547 5.5663 11.4547 5.80771V10.0468H15.701C15.9428 10.0468 16.1747 10.1427 16.3457 10.3134C16.5167 10.4841 16.6128 10.7156 16.6128 10.957C16.6128 11.1984 16.5167 11.4299 16.3457 11.6006C16.1747 11.7713 15.9428 11.8672 15.701 11.8672H11.4547V16.1064C11.4547 16.3478 11.3586 16.5793 11.1876 16.75C11.0167 16.9207 10.7847 17.0166 10.5429 17.0166C10.3011 17.0166 10.0692 16.9207 9.89823 16.75C9.72724 16.5793 9.63119 16.3478 9.63119 16.1064V11.8672H5.38486C5.14305 11.8672 4.91114 11.7713 4.74015 11.6006C4.56917 11.4299 4.47311 11.1984 4.47311 10.957C4.47311 10.7156 4.56917 10.4841 4.74015 10.3134C4.91114 10.1427 5.14305 10.0468 5.38486 10.0468H9.63119V5.80771C9.63119 5.5663 9.72724 5.33479 9.89823 5.16409C10.0692 4.9934 10.3011 4.8975 10.5429 4.8975Z",
    fill: "#FF7A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusOrangeVector);
export default __webpack_public_path__ + "static/media/Plus_orange_Vector.1ea5b5b66bbea22aaacb9568b29a3c1c.svg";
export { ForwardRef as ReactComponent };